import { PropMarker } from "./PropMarker";

export type ClusteredPropMarkersProps = {
  props: Property[];
  onClick: (prop: Property) => void;
};

export const ClusteredPropMarkers = ({
  props,
  onClick,
}: ClusteredPropMarkersProps) => {
  return (
    <>
      {props.map((prop) => (
        <PropMarker key={prop.id} onClick={onClick} prop={prop} />
      ))}
    </>
  );
};
